/** Shiro’s V15.4 — Native Shopify product pages with a safe menu fallback.
 * Always prefer the canonical /products/<handle> page when published to Online Store.
 * Shopify's Ajax Product API returns 404 for products that are not publicly available.
 * Category tile photos use Shopify's uploaded product media when available.
 * No inventory or price changes, no cart actions, no cross-origin AIO manipulation.
 */
(function () {
  'use strict';
  var cache = new Map();
  function root(){return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';}
  function fallback(handle){return root()+'pages/menu?product='+encodeURIComponent(handle);}
  function get(handle){
    if(!cache.has(handle)){
      cache.set(handle,fetch(root()+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'})
        .then(function(res){if(!res.ok) return null;return res.json();})
        .catch(function(){return null;}));
    }
    return cache.get(handle);
  }
  function hydrate(node){
    var handle=node.getAttribute('data-shiros-handle');
    if(!handle)return;
    get(handle).then(function(product){
      if(!product)return;
      var img=node.querySelector('img');
      if(img && product.featured_image && img.getAttribute('data-shiros-photo-locked')!=='true'){
        // Existing theme photo is a fallback until the owner uploads native Shopify media.
        img.src=product.featured_image;
        img.removeAttribute('srcset');
        img.alt=product.title+' from Shiro’s Bakery & Cafe';
      }
    });
  }
  function boot(){
    var images=document.querySelectorAll('[data-shiros-product-photo]');
    if('IntersectionObserver' in window){
      var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(!e.isIntersecting)return;obs.unobserve(e.target);hydrate(e.target);});},{rootMargin:'200px'});
      images.forEach(function(node){obs.observe(node);});
    }else{images.forEach(hydrate);}
  }
  // A normal click checks that the product is publicly available before
  // navigating; controls and modifier-clicks retain native browser behavior.
  document.addEventListener('click',function(event){
    if(event.defaultPrevented || event.button!==0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)return;
    var target=event.target instanceof Element?event.target:null;
    var a=target && target.closest('a[data-shiros-native-product][data-shiros-handle]');
    if(!a || a.hasAttribute('download') || a.getAttribute('target')==='_blank')return;
    var handle=a.dataset.shirosHandle;
    if(!handle)return;
    event.preventDefault();
    get(handle).then(function(product){
      window.location.assign(product ? a.href : fallback(handle));
    });
  },false);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
